<app-tracking-header [name]="name" />
<div class="wrapper">
  <div class="filters" [class.hide-sidebar]="!showSidebar()">
    <app-tracking-sidebar
      [isLoading]="isLoading"
      [selectors]="currentSelectors"
      [inceptionInterval]="inceptionInterval"
      [userPreferences]="userPreferences"
      [autoSelectSavedView]="currentView !== 'defaultview'"
      (filtersChanged)="this.filtersChange($event)"
      (inceptionDateChanged)="this.inceptionDateChanged.emit($event)"
      (saveTrackingPreferences)="this.saveTrackingPreferences.emit($event)"
      (setTrackingPreferences)="this.setTrackingPreferences.emit($event)"
      (deleteTrackingPreferences)="this.deleteTrackingPreferences.emit($event)"
      (updateTrackingPreferences)="this.updateTrackingPreferences.emit($event)"
    ></app-tracking-sidebar>
    <button
      class="toggle-button"
      [class.closed]="!showSidebar()"
      (click)="showSidebar.set(!showSidebar())"
    >
      <i
        class="fi"
        [class.fi-rs-filter-slash]="showSidebar()"
        [class.fi-rs-filter]="!showSidebar()"
      >
      </i>
    </button>
  </div>
  <div class="tab-container">
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      @if (!isProduction) {
        <mat-tab label="My View">
          <ng-template matTabContent>
            <app-tracking-views
              #myViewRef
              [currentviewType]="'my view'"
              [isLoading]="isLoading"
              [selectors]="currentSelectors"
              [inceptionInterval]="inceptionInterval"
              [trackingData]="trackingData"
              [trackingMyViewsData]="trackingMyViewsData"
              [usersResponse]="usersResponse?.data"
              (filtersChanged)="this.filtersChangeMyView($event)"
              (inceptionDateChanged)="this.inceptionDateChanged.emit($event)"
              (saveTrackingPreferences)="this.saveTrackingPreferences.emit($event)"
              (setTrackingPreferences)="this.setTrackingPreferences.emit($event)"
              (updateColumnValue)="this.updateColumnValue.emit($event)"
              (updateUserValue)="this.updateUserValue.emit($event)"
              (updateComment)="this.updateComment.emit($event)"
            >
            </app-tracking-views>
          </ng-template>
        </mat-tab>
        <mat-tab label="Team View">
          <ng-template matTabContent>
            <app-tracking-views
              #myViewRef
              [currentviewType]="'team view'"
              [isLoading]="false"
              [selectors]="currentSelectors"
              [inceptionInterval]="inceptionInterval"
              [trackingData]="trackingData"
              [trackingMyViewsData]="trackingTeamViewsData"
              [usersResponse]="usersResponse?.data"
              (filtersChanged)="this.filtersChange($event)"
              (inceptionDateChanged)="this.inceptionDateChanged.emit($event)"
              (saveTrackingPreferences)="this.saveTrackingPreferences.emit($event)"
              (setTrackingPreferences)="this.setTrackingPreferences.emit($event)"
              (updateColumnValue)="this.updateColumnValue.emit($event)"
              (updateUserValue)="this.updateUserValue.emit($event)"
              (updateComment)="this.updateComment.emit($event)"
            >
            </app-tracking-views>
          </ng-template>
        </mat-tab>
      }
      <mat-tab label="Tracking View">
        <ng-template matTabContent>
          <app-tracking-main
            [isLoading]="false"
            [isDetailsLoading]="isDetailsLoading"
            [selectors]="selectors"
            [inceptionInterval]="inceptionInterval"
            [trackingData]="trackingData"
            [filtersData]="filtersData"
            (filtersChanged)="this.filtersChange($event)"
            (fetchTrackingDetails)="this.fetchTrackingDetails.emit($event)"
            (filteredSelectorsChange)="this.onFilteredSelectorsChange($event)"
            (inceptionDateChanged)="this.inceptionDateChanged.emit($event)"
            (saveTrackingPreferences)="this.saveTrackingPreferences.emit($event)"
            (setTrackingPreferences)="this.setTrackingPreferences.emit($event)"
            (updateComplete)="this.updateComplete.emit($event)"
          >
          </app-tracking-main>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  @if (currentView !== "defaultview") {
    <button class="export-button" (click)="onExportClick()" appButton big accent border>
      <span>Export</span>
    </button>
  }
</div>
